module.exports = __webpack_public_path__ + "img/CORONAVIRUS_POP-UP-SITE-297X1104CM.e01d17a4.png";